<template lang="pug">
RouterLink.estate-link(:to=" '/estates/' + camelized.id " :target="props.target")
  template(v-if="slots.default")
    slot
  template(v-else)
    span {{ camelized.fullName || "ESTATE NAME IS BLANK" }}
</template>

<script setup>
import { useSlots, computed } from 'vue'
import { RouterLink } from 'vue-router'
import { utils } from '@/utils'

const slots = useSlots();

const props = defineProps({
  estate: {type: Object, default: {} }, 
  target: {type: String, default: null },
})

// this allows this component to work whether the props.estate has camelized json 
// keys or regular/underscore
const camelized = computed(() => utils.camelizeKeysDeep(props.estate))
</script>